import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useGetAllClientsQuery } from "../slices/getqueries/getqueriesApi";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../slices/authslice";
import DashboardActive from '../assets/Dashboard_Active.svg'
import DashboardInactive from '../assets/Dashboard_Inactive.svg'
import PlansActive from '../assets/Plans_Active.svg'
import PlansInactive from '../assets/Plans_Inactive.svg'
const Sidebar = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { clientId, isAdmin, permissions, role } = userInfo;
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen);
  };
  const reduxdispatch = useDispatch();
  const {
    data: getAllClients,
    isLoading: loadingAllClients,
    error: errorAllClients,
  } = useGetAllClientsQuery({ clientname: clientId });
  console.log(getAllClients);
  const options = getAllClients?.map((item) => {
    return item.clientname;
  });
  const navItems = [
    {
      name: "Dashboard",
      path: "/",
      activeImg: DashboardActive,
      inactiveImg: DashboardInactive
    },
    {
      name: "Plans",
      path: "/currentplan",
      activeImg: PlansActive,
      inactiveImg: PlansInactive
    },

  ]

  
  return (
    <>
<div className="bg-white">
  <nav className="flex flex-col items-center space-y-4 w-full sm:pt-4 md:pt-0">
  {navItems.map((item) => (
    <NavLink
      key={item.name}
      to={item.path}
      className={({ isActive }) =>
        `flex flex-col items-center justify-center gap-1 px-2 py-3 rounded-lg transition-all w-full text-center
        ${
          isActive
            ? 'text-[#204887] font-semibold hover:text-[#204887]'
            : 'text-gray-700 font-normal hover:text-[#204887]'
        }`
      }
    >
      {({ isActive }) => (
        <>
          <img
            src={isActive ? item.activeImg : item.inactiveImg}
            alt={item.name}
            className="w-10 h-10"
          />
          <span className="text-[14px] break-words leading-snug">
            {item.name}
          </span>
        </>
      )}
    </NavLink>
  ))}
</nav>
</div>
</>
  )
}

export default Sidebar;
